/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EstimatedDailyLaborCostDtoPage } from '../../models/estimated-daily-labor-cost-dto-page';

export interface ListEstimatedDailyLaborCosts$Params {
  projectIds?: Array<string>;
  wpIds?: Array<string>;
  userIds?: Array<string>;
  from?: string | null;
  to?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'computedEstimatedDailyLaborCosts' | '-computedEstimatedDailyLaborCosts' | 'laborCostId' | '-laborCostId' | 'laborCost' | '-laborCost' | 'user' | '-user' | 'laborName' | '-laborName' | 'totalHour' | '-totalHour' | 'percentage' | '-percentage' | 'id' | '-id' | 'from' | '-from' | 'to' | '-to' | 'total' | '-total' | 'project' | '-project' | 'budget' | '-budget' | 'budgetVersionId' | '-budgetVersionId' | 'budgetName' | '-budgetName' | 'costType' | '-costType' | 'costTypeName' | '-costTypeName' | 'workPackage' | '-workPackage' | 'workPackageName' | '-workPackageName' | 'comment' | '-comment' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'consumption' | '-consumption' | 'consumptionPerc' | '-consumptionPerc'>;
}

export function listEstimatedDailyLaborCosts(http: HttpClient, rootUrl: string, params?: ListEstimatedDailyLaborCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedDailyLaborCostDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listEstimatedDailyLaborCosts.PATH, 'get');
  if (params) {
    rb.query('projectIds', params.projectIds, {});
    rb.query('wpIds', params.wpIds, {});
    rb.query('userIds', params.userIds, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EstimatedDailyLaborCostDtoPage>;
    })
  );
}

listEstimatedDailyLaborCosts.PATH = '/v0/estimatedLaborCost/daily';
